import React, {useRef, useState} from 'react';
import {AS} from './fonts/AS';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import {Colors} from '../Abstracts/Colors';

interface SpecialWomansProps {
  name: 'Hawwa' | 'Maryam';
}

const SCSpecialWoman = styled(motion.span)`
  position: relative;
  text-decoration: underline;
  cursor: pointer;
  .latinName {
    position: absolute;
    background-color: ${Colors.facebookBlue};
    color: white;
    white-space: nowrap;
    border-radius: 5px;
    left: 0;
    top: -28px;
    padding: 0.3rem;
    pointer-events: none;
    z-index: 100;
  }
  @media screen and (min-width: 800px) {
    .latinName {
      color: black;
    }
  }
`;

export function SpecialWoman(props: SpecialWomansProps) {
  const specialWomansLatinNames = {
    Hawwa: 'Eva',
    Maryam: 'Maria',
  };

  const nameRef = useRef<HTMLSpanElement>(null);
  const [activeTooltip, setActiveTooltip] = useState(false);

  const variants = {
    visible: {opacity: 1},
    hidden: {opacity: 0},
  };

  return (
    <SCSpecialWoman
      onClick={() => setActiveTooltip(!activeTooltip)}
      onMouseEnter={() => setActiveTooltip(true)}
      onMouseLeave={() => setActiveTooltip(false)}
    >
      {props.name} <AS />
      <motion.span
        className="latinName"
        variants={variants}
        animate={activeTooltip ? 'visible' : 'hidden'}
      >
        {specialWomansLatinNames[props.name]}
      </motion.span>
    </SCSpecialWoman>
  );
}
